// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_SyncSubaccountInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/anticipations/sync_subaccount/{subaccount_id}
 *
 * No body required — subaccount_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_SyncSubaccountInput {}

registerContract('SubaccountsAnticipations_SyncSubaccountInput', {})
